<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="data-list-list-view" class="data-list-container">
        <vs-table
            ref="table"
            no-data-text="Nenhuma lista de favoritos encontrada"
            pagination
            :max-items="itemsPerPage"
            :data="favoriteLists"
        >
            <div slot="header" class="flex w-full items-end">
                <div>
                    <vs-input
                        placeholder="Buscar"
                        class="w-full input-rounded-full no-icon-border mr-4"
                        icon="icon-search"
                        icon-pack="feather"
                        v-model="term"
                        @keyup.enter="searchHandler()"
                    />
                </div>
                <div
                    slot="header"
                    class="flex flex-wrap-reverse items-center flex-grow justify-end"
                >
                    <div class="flex flex-wrap-reverse items-start">
                        <vs-input
                            class="mr-4"
                            label="ID"
                            placeholder="ID"
                            v-model="id"
                            disabled
                            v-if="isEditing"
                        />

                        <vs-input
                            class="mr-4"
                            label="Nome"
                            placeholder="Nome da lista de favoritos"
                            v-model="name"
                        />

                        <vs-select class="mr-4" label="Privado?" v-model="isPrivate">
                            <vs-select-item value text="Selecione..." />
                            <vs-select-item key="Y" value="Y" text="Sim" />
                            <vs-select-item key="N" value="N" text="Não" />
                        </vs-select>

                        <vs-button
                            class="mr-4"
                            color="success"
                            type="filled"
                            @click="createFavoriteListHandler"
                            v-if="!isEditing"
                        >Criar</vs-button>

                        <vs-button
                            class="mr-4"
                            color="danger"
                            type="filled"
                            @click="cancelEditFavoriteList"
                            v-if="isEditing"
                        >Cancelar</vs-button>

                        <vs-button
                            class="mr-4"
                            color="success"
                            type="filled"
                            @click="updateFavoriteListHandler"
                            v-if="isEditing"
                        >Salvar</vs-button>
                    </div>
                </div>
            </div>

            <template slot="thead">
                <vs-th sort-key="id">ID</vs-th>
                <vs-th sort-key="title_default">Lista de favoritos</vs-th>
                <vs-th sort-key="title_default">Privado?</vs-th>
                <vs-th>&nbsp;</vs-th>
            </template>

            <template slot-scope="{ data }">
                <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            <p class="term font-medium">{{ tr.id }}</p>
                        </vs-td>
                        <vs-td>
                            <p class="term font-medium">{{ tr.name }}</p>
                        </vs-td>
                        <vs-td>
                            <p class="term font-medium">{{ tr.private }}</p>
                        </vs-td>
                        <vs-td>
                            <router-link :to="`/documents-favorite-lists/${tr.id}`">
                                <vx-tooltip
                                    text="Ver documentos nesta lista"
                                    class="w-6 h-6"
                                    color="grey"
                                >
                                    <feather-icon icon="EyeIcon" class="w-6 h-6"></feather-icon>
                                </vx-tooltip>
                            </router-link>
                        </vs-td>
                        <vs-td>
                            <router-link
                                :to="`/users_favorite_lists/${tr.id}`"
                                v-if="tr.private === 'Sim'"
                            >
                                <vx-tooltip
                                    text="Ver usuários nessa lista"
                                    class="w-6 h-6"
                                    color="grey"
                                >
                                    <feather-icon icon="UsersIcon" class="w-6 h-6"></feather-icon>
                                </vx-tooltip>
                            </router-link>
                        </vs-td>
                        <vs-td>
                            <div class="flex items-center">
                                <span @click="editFavoriteListHandler(tr)" class="mr-4">
                                    <vx-tooltip text="Editar" class="w-6 h-6">
                                        <feather-icon icon="EditIcon" class="w-6 h-6"></feather-icon>
                                    </vx-tooltip>
                                </span>
                                <span @click="confirmDeleteFavoriteList(tr.id)">
                                    <vx-tooltip text="Apagar" class="w-6 h-6" color="danger">
                                        <feather-icon icon="XCircleIcon" class="w-6 h-6"></feather-icon>
                                    </vx-tooltip>
                                </span>
                            </div>
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>
    </div>
</template>

<script>
import { sync, call } from "vuex-pathify";
export default {
    data() {
        return {
            itemsPerPage: 40,
            isMounted: false
        };
    },
    computed: {
        ...sync([
            "favoriteList/id",
            "favoriteList/favoriteLists",
            "favoriteList/selectedItems",
            "favoriteList/term",
            "favoriteList/name",
            "favoriteList/isPrivate"
        ]),
        isEditing() {
            return this.id !== null;
        }
    },
    async created() {
        // Reset page state
        this.reset();

        this.$vs.loading();

        try {
            await this.fetch();
            this.$vs.loading.close();
        } catch (error) {
            this.$vs.loading.close();
            this.$vs.notify({
                title: "Erro",
                text:
                    "Não foi possível carregar esta página. Tente novamente mais tarde, por favor.",
                color: "danger",
                iconPack: "feather",
                icon: "icon-alert-circle"
            });
        }
    },
    async mounted() {
        this.isMounted = true;
    },
    methods: {
        ...call([
            "favoriteList/fetch",
            "favoriteList/update",
            "favoriteList/reset",
            "favoriteList/createFavoriteList",
            "favoriteList/deleteFavoriteList",
            "favoriteList/updateFavoriteList"
        ]),
        async searchHandler() {
            this.$vs.loading();
            try {
                await this.fetch();
                this.$vs.loading.close();
            } catch (error) {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Erro",
                    text:
                        "Não foi possível carregar esta página. Tente novamente mais tarde, por favor.",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            }
        },
        async createFavoriteListHandler() {
            this.$vs.loading();
            await this.createFavoriteList();
            this.$vs.notify({
                title: "Criado",
                text: "Lista de favoritos criada com sucesso",
                color: "success",
                iconPack: "feather",
                icon: "icon-alert-circle"
            });
            this.$vs.loading.close();
        },

        confirmDeleteFavoriteList(id) {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Tem certeza que deseja excluir a lista de favoritos?",
                text:
                    "Todos os documentos atrelados não farão mais parte desta lista.",
                acceptText: "Deletar",
                cancelText: "Cancelar",
                accept: () => this.deleteHandlerFavoriteList(id)
            });
        },
        async deleteHandlerFavoriteList(id) {
            this.$vs.loading();
            await this.deleteFavoriteList(id);
            this.$vs.loading.close();
            this.$vs.notify({
                title: "Excluída com sucesso!",
                text: "Lista de favoritos foi excluída com sucesso!",
                color: "success",
                iconPack: "feather",
                icon: "icon-alert-circle"
            });
        },
        async editFavoriteListHandler(favoriteList) {
            this.id = favoriteList.id;
            this.name = favoriteList.name;
            this.isPrivate = favoriteList.private;
        },
        cancelEditFavoriteList() {
            this.id = null;
            this.name = "";
            this.idPrivate = "";
        },
        async updateFavoriteListHandler() {
            this.$vs.loading();

            try {
                await this.updateFavoriteList();
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "lista Atualizada!",
                    text: "A lista de favoritos foi atualizada com sucesso!",
                    color: "success",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            } catch (error) {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Erro",
                    text: error.message,
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            }
        }
    }
};
</script>

<style lang="scss">
#data-list-list-view {
    .vs-con-table {
        .vs-table--header {
            display: flex;
            flex-wrap: wrap-reverse;
            margin-left: 1.5rem;
            margin-right: 1.5rem;
            > span {
                display: flex;
                flex-grow: 1;
            }

            .vs-table--search {
                padding-top: 0;

                .vs-table--search-input {
                    padding: 0.9rem 2.5rem;
                    font-size: 1rem;

                    & + i {
                        left: 1rem;
                    }

                    &:focus + i {
                        left: 1rem;
                    }
                }
            }
        }

        .vs-table {
            border-collapse: separate;
            border-spacing: 0 1.3rem;
            padding: 0 1rem;

            tr {
                box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
                td {
                    padding: 20px;
                    &:first-child {
                        border-top-left-radius: 0.5rem;
                        border-bottom-left-radius: 0.5rem;
                    }
                    &:last-child {
                        border-top-right-radius: 0.5rem;
                        border-bottom-right-radius: 0.5rem;
                    }
                }
                td.td-check {
                    padding: 20px !important;
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 0;
                padding-bottom: 0;

                .vs-table-text {
                    text-transform: uppercase;
                    font-weight: 600;
                }
            }
            th.td-check {
                padding: 0 15px !important;
            }
            tr {
                background: none;
                box-shadow: none;
            }
        }

        .vs-table--pagination {
            justify-content: center;
        }

        // vs-button
        .vs-button {
            margin-left: 20px;
        }
    }
}
</style>